export default __webpack_public_path__ + "static/media/trustero_logo_mini.26fb4728.svg";